import { getOptionValue, toPositiveOptionId } from '@/utils/optionValues';
import { SUPPLIERS_TEXT } from '@/texts/catalog/suppliers';

export const createInitialSupplierForm = () => ({
  name: '',
  status: SUPPLIERS_TEXT.modal.status.active,
  classOption: null,
  categoryOption: null,
  areaOption: null,
  specialties: [],
  email: '',
  phone: '',
  website: '',
  portfolio: '',
  comment: '',
  address: '',
  country: null,
  state: null,
  city: '',
  zipCode: '',
  accountingAccount: '',
});

export const buildSupplierFormFromEntity = (entity = {}) => {
  const base = createInitialSupplierForm();
  const specialties = Array.isArray(entity?.specialties)
    ? entity.specialties
    : [];
  const normalizedStatus = Number(entity?.active ?? entity?.is_active ?? 1) === 0
    ? SUPPLIERS_TEXT.modal.status.inactive
    : SUPPLIERS_TEXT.modal.status.active;

  return {
    ...base,
    name: String(entity?.name || '').trim(),
    status: normalizedStatus,
    classOption: getOptionValue(entity?.class?.id ?? entity?.class_id),
    categoryOption: getOptionValue(entity?.category?.id ?? entity?.category_id),
    areaOption: getOptionValue(entity?.area?.id ?? entity?.area_id),
    specialties: specialties
      .map((specialty) => getOptionValue(specialty?.id ?? specialty?.value ?? specialty))
      .filter((specialtyId) => Number(specialtyId || 0) > 0),
    email: String(entity?.email || '').trim(),
    phone: String(entity?.phone || '').trim(),
    website: String(entity?.website || '').trim(),
    portfolio: String(entity?.portfolio || '').trim(),
    comment: String(entity?.comments || entity?.comment || '').trim(),
    address: String(entity?.address || '').trim(),
    country: getOptionValue(entity?.country),
    state: getOptionValue(entity?.state),
    city: String(entity?.city || '').trim(),
    zipCode: String(entity?.zipcode || entity?.zipCode || '').trim(),
    accountingAccount: String(entity?.reference || entity?.accountingAccount || '').trim(),
  };
};

export const buildSupplierPayload = (form = {}) => {
  const normalizedStatus = String(form?.status || '').trim().toLowerCase();

  return {
    name: String(form?.name || '').trim(),
    active: normalizedStatus === SUPPLIERS_TEXT.modal.status.inactive.toLowerCase() ? 0 : 1,
    class_id: toPositiveOptionId(form?.classOption),
    category_id: toPositiveOptionId(form?.categoryOption),
    area_id: toPositiveOptionId(form?.areaOption),
    email: String(form?.email || '').trim(),
    phone: String(form?.phone || '').trim(),
    website: String(form?.website || '').trim(),
    portfolio: String(form?.portfolio || '').trim(),
    comments: String(form?.comment || '').trim(),
    reference: String(form?.accountingAccount || '').trim(),
    address: String(form?.address || '').trim(),
    country: String(getOptionValue(form?.country) || '').trim(),
    state: String(getOptionValue(form?.state) || '').trim(),
    city: String(form?.city || '').trim(),
    zipcode: String(form?.zipCode || '').trim(),
  };
};

export const resolveSpecialtyIds = (form = {}) => {
  return (Array.isArray(form?.specialties) ? form.specialties : [])
    .map((option) => toPositiveOptionId(option))
    .filter((id) => id > 0);
};
